module.exports = __webpack_public_path__ + "img/courses.e891f1a4.svg";